import { FC, memo } from 'react'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import ActionSheet from '../../action-sheet'
import { useSelector } from 'react-redux'
import { getCurrentOpenedFilterModal } from '../../../../redux/filters'
import { FilterModalType } from '../../filter-sort-section/types'
import FilterModalHeader from './header'
import SortContent from '../../filter-sort-section/sort-section/sort-content'

type Props = {
    filterStaticData: FilterSectionTransport
    handleModalToggle: () => void
    handleSortSubmit: (link: string) => void
}

const SortModal: FC<Props> = ({ handleModalToggle, handleSortSubmit }) => {
    const currentOpenedFilterModal = useSelector(getCurrentOpenedFilterModal)
    const isOpen = currentOpenedFilterModal === FilterModalType.SORT

    return (
        <ActionSheet
            isOpen={isOpen}
            onRequestClose={handleModalToggle}
            header={<FilterModalHeader handleFilterToggle={handleModalToggle} />}
        >
            <SortContent className="sort-content" handleSortSubmit={handleSortSubmit} isModal isSortOpen={isOpen} />
        </ActionSheet>
    )
}

export default memo(SortModal)
